import {IGeometryEditsDispatcher, IPaylodAction, IActionDispatcher} from '../../interfaces/dispatchers'
import {IStore} from '../../interfaces/reducers'
import {ISetEditingGeometriesProps} from '../../interfaces/models'

export class GeometryEditsDispatcher implements IGeometryEditsDispatcher {
  constructor() {
    this.toggleOSnap = this.toggleOSnap.bind(this)
    this.togglePolarTracking = this.togglePolarTracking.bind(this)
    this.setProps = this.setProps.bind(this)
  }

  public toggleOSnap(active: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {}
  }
  public togglePolarTracking(active: boolean) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {}
  }
  public setProps(props: ISetEditingGeometriesProps) {
    return (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IStore) => {}
  }
}
